import { Injectable, EventEmitter  } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ShopCommonService {

  supplierRefId:any;
  adminRFQId:any;

  private dataSource = new Subject<any>();
  public currentData$ = this.dataSource.asObservable();

  private updateSidebarNav: Subject<any> = new Subject<any>();
  updateSidebarNav$: Observable<any> = this.updateSidebarNav.asObservable();

  private updateTableData: Subject<any> = new Subject<any>();
  updateTableData$: Observable<any> = this.updateTableData.asObservable();

  private setSidebarData: Subject<any> = new Subject<any>();
  setSidebarData$: Observable<any> = this.setSidebarData.asObservable();

  dataRefreshed: EventEmitter<void> = new EventEmitter<void>();

  refreshData() {
    this.dataRefreshed.emit();
  }
  

  constructor() { 
    this.supplierRefId = '';
    this.adminRFQId = '';
  }

  updateSideNav(view:String) {
    this.updateSidebarNav.next(view);
  }

  

  updateTablesData(view:boolean) {
    this.updateTableData.next(view);
  }

  updateSidebarData(sidebarData: any) {
    this.setSidebarData.next(sidebarData);
  }

  setIndirectCatId(data: any) {
    this.dataSource.next(data);
  }

  getIndirectCatId() {
    return this.currentData$;
  }
}
